import React from 'react';
import phone from '../../assets/Pantja-Laundry-Apps.png';
import android from '../../assets/Pantja-Laundry-Apps-Download-Playstore.png';
import apple from '../../assets/Pantja-Laundry-Apps-Download-Appstore.png';

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';
import './download.css';

const Download = () => {
  return (
    <div className='pl__download section__padding' id='apps'>
      <div className='pl__download-img'>
        <AnimationOnScroll animateIn="animate__fadeInLeft">
          <img src={phone} alt="Download Aplikasi Pantja Laundry" />
        </AnimationOnScroll>
      </div>
      <div className='pl__download-container'>
        <div className='pl__download-container_title'>
          <p>Pesan penjemputan pakaian secara GRATIS dan Track Proses cucian Anda dengan 1 aplikasi Pantja Laundry. Lihat harga, Membership Discount, Point yang dikumpulkan, dan Penukaran Merchandise ada di Aplikasi.</p>
          <h1 className='gradient__text'>Download Aplikasinya & Kumpulkan Point Untuk Mendapatkan Diskon & Merchandise Eksklusif !<span>*</span></h1>
        </div>
        <div className='pl__download-container-button'>
          <p>Download Now</p>
          <div className='pl__download-container_btn'>
            <div className='pl__download-container_btn-android'>
              <img src={android} alt="Pantja Laundry on PlayStore" />
            </div>
            <div className='pl__download-container_btn-apple'>
              <img src={apple} alt="Pantja Laundry on AppStore" />
            </div>
          </div>
          <p>*Konten belum tersedia saat ini</p>
        </div>
      </div>
    </div>
  )
}

export default Download


